import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useExportarXml } from '../../../../hooks/useSngpc';

interface BotaoExportarXmlProps {
    disabled?: boolean;
}

const BotaoExportarXml: React.FC<BotaoExportarXmlProps> = ({ disabled }) => {
    const exportarXmlMutation = useExportarXml();

    const handleExportar = async () => {
        try {
            await exportarXmlMutation.mutateAsync();
        } catch (error) {
            console.error('Erro ao exportar XML:', error);
        }
    };

    return (
        <Button
            variant="success"
            onClick={handleExportar}
            disabled={disabled || exportarXmlMutation.isPending}
        >
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            {exportarXmlMutation.isPending ? 'Exportando...' : 'Exportar XML'}
        </Button>
    );
};

export default BotaoExportarXml; 